import { render } from "./DepositComponent.vue?vue&type=template&id=639f1cff&scoped=true"
import script from "./DepositComponent.vue?vue&type=script&lang=js"
export * from "./DepositComponent.vue?vue&type=script&lang=js"

import "./DepositComponent.vue?vue&type=style&index=0&id=639f1cff&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639f1cff"]])

export default __exports__